import { render, staticRenderFns } from "./CompanyComponentView.vue?vue&type=template&id=ffff1e96&scoped=true"
import script from "./CompanyComponentView.vue?vue&type=script&lang=js"
export * from "./CompanyComponentView.vue?vue&type=script&lang=js"
import style0 from "./CompanyComponentView.vue?vue&type=style&index=0&id=ffff1e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffff1e96",
  null
  
)

export default component.exports